<template>
  <div :class="$style.wrapper">
    <Score />
    <stripes />
    <Chars />
    <div :class="$style.testWrap" v-if="!finished">
      <TestComp
        ref="test"
        :question="question.question"
        :disabled="disabled"
        :result="result"
        :type="question.type"
        :answers="question.answers"
        @showButton="button = true"
        @hideButton="button = false"
        :current="step"
        :length="test.length"
        @input="commitChanges"
      />
      <div :class="$style.buttonWrapper">
        <transition name="button-fade-fast">
          <v-btn fluid v-if="button" @click="nextStep">{{result ? 'Продолжить' : 'Проверить'}}</v-btn>
        </transition>
      </div>
    </div>
    <transition name="fade">
      <Result v-if="finished" />
    </transition>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'

import Score from '@/components/@layout/Score/Score'
import Chars from '@/components/@ui/Chars/Chars'
import TestComp from '@/components/Test/Test'
import Result from '@/components/Result'

export default {
  name: 'Test',
  components: {
    Score, Chars, TestComp, Result,
  },
  data() {
    return {
      step: 1,
      test: cloneDeep(require('./test.json')),
      result: false,
      button: false,
      disabled: false,
      finished: false,
    }
  },
  computed: {
    question() {
      return this.test[this.step - 1]
    },
  },
  methods: {
    commitChanges(res) {
      this.$store.commit('SET_RESULT', res)
    },
    showButton() {
      this.button = true
      this.result = true

      this.$refs.test.stepResult()
    },

    nextStep() {
      const { result, step } = this

      if (result && (this.step === this.test.length)) {
        this.finished = true
        return
      }

      if (result) {
        this.step = step + 1
        this.button = false
        this.disabled = false
      }

      if (!result) {
        this.disabled = true
        this.button = false
        setTimeout(this.showButton, 800)
        return
      }
      this.result = !result
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  height: 100%;
}
.testWrap {
  margin: 0 auto;
  padding-top: 12.9rem;
}

.buttonWrapper {
  text-align: center;
  margin-top: 7.5rem;
}
</style>
